import { Box, IconButton, styled, Typography } from "@mui/material";
import React, { FC } from "react";
import { Order } from "../../dto/orderSummaryTypes";
import {
  mainContainer,
  orderStyles,
  spaceBetween,
  textStyle,
  titleStyle,
  titleWithEditContainer,
  deleteIconStyle,
} from "./orderListStyles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import deleteIcon from "../../assets/deleteIcon.png";

const StyledImage = styled("img")`
  width: 70px;
  object-fit: contain;
  margin-left: 20px;

  @media (max-width: 600px) {
    width: 67px;
  }
`;

type UpdateOrderProps = {
  updateItem: (id: string) => void;
  isEditable: boolean;
  onDelete?: (id: string) => void;
  isDeleting?: boolean;
};

export const OrderListItem: FC<Order & UpdateOrderProps> = ({
  id,
  image,
  isEditable,
  liters,
  name,
  quantity,
  updateItem,
  onDelete,
  isDeleting = false,
}) => (
  <Box sx={mainContainer}>
    <StyledImage src={image ?? ""} alt={name} />
    <Box sx={orderStyles}>
      <Box sx={spaceBetween}>
        <Box sx={titleWithEditContainer}>
          <Typography sx={titleStyle}>{name}</Typography>
          {isEditable && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                <IconButton
                  onClick={() => updateItem(id)}
                  disabled={isDeleting}
                >
                  <EditOutlinedIcon color="primary" />
                </IconButton>
                <IconButton
                  onClick={() => onDelete?.(id)}
                  disabled={isDeleting}
                >
                  <Box
                    component="img"
                    src={deleteIcon}
                    alt="Delete"
                    sx={deleteIconStyle}
                  />
                </IconButton>
              </Box>
            </>
          )}
        </Box>
        <Box>
          <Typography sx={textStyle}>
            Quantity: ({quantity} x {liters}) {quantity * liters} L
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
);
